export default __webpack_public_path__ + "static/media/coverVideo.4b271549.mp4";